export const LEFT_NAV_ITEM_VALID_ATTRIBUTE_TYPES: string[] = [
  'gotoContext',
  'href',
  'routerLink',
  'uiSref'
]
